import { createRouter, createWebHistory } from 'vue-router';
// import { auth } from '@/stores/api';
// import type { AuthGetCurrentUserAPI } from '@/packages/API/Resources/AuthAPI';
// import { APIResponse } from '@/libs/API';
import { axios } from '@/stores/axios';

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/:hash',
      meta: { restricted: true },
      component: () => import('@/components/Templates/Layout.vue'),
      children: [
        {
          path: '',
          component: () => import('@/components/Pages/Dashboard.vue'),
          meta: { title: '' },
        },
        {
          path: ':section_hash',
          component: () => import('@/components/Pages/Section/Section.vue'),
          children: [
            {
              path: '',
              component: () => import('@/components/Pages/Section/SectionCalendar.vue'),
            },
            {
              path: 'reservation',
              component: () => import('@/components/Pages/Section/Reservation/ReservationList.vue'),
            },
            {
              path: 'reservation/detail',
              component: () =>
                import('@/components/Pages/Section/Reservation/ReservationDetail.vue'),
            },
            {
              path: 'reservation/create',
              component: () =>
                import('@/components/Pages/Section/Reservation/ReservationCreate.vue'),
            },
            {
              path: 'reservation/:id',
              component: () => import('@/components/Pages/Section/Reservation/ReservationEdit.vue'),
            },
            {
              path: 'reservation/confirm/:id',
              component: () =>
                import('@/components/Pages/Section/Reservation/ReservationConfirm.vue'),
            },
            // {
            //   path: 'settings',
            //   component: () => import('@/components/Pages/Section/SectionSettings.vue'),
            // },
            // {
            //   path: 'checkitems',
            //   component: () => import('@/components/Pages/Section/Checkitems/Edit.vue'),
            // },
            {
              path: 'settings',
              component: () => import('@/components/Pages/Section/Settings.vue'),
            },
            {
              path: 'unit',
              component: () => import('@/components/Pages/Section/Unit/UnitList.vue'),
            },
            {
              path: 'patient',
              meta: { title: '予約者検索' },
              component: () => import('@/components/Pages/Section/Patient/PatientSearch.vue'),
            },
            {
              path: 'patient/:id',
              meta: { title: '予約者検索' },
              component: () => import('@/components/Pages/Section/Patient/PatientList.vue'),
            },
          ],
        },

        {
          path: 'questionnaire',
          name: 'questionnaire',
          component: () => import('@/components/Pages/Questionnaire/List.vue'),
        },
        {
          path: 'questionnaire/create',
          name: 'questionnaireCreate',
          component: () => import('@/components/Pages/Questionnaire/Create.vue'),
        },
        {
          path: 'questionnaire/:id',
          name: 'questionnaireEdit',
          component: () => import('@/components/Pages/Questionnaire/Edit.vue'),
        },
      ],
    },
    {
      path: '/login',
      name: 'login',
      meta: { restricted: false, title: 'ログイン' },
      component: () => import('@/components/Pages/Login.vue'),
    },
    {
      path: '/logout',
      name: 'logout',
      meta: { restricted: false, title: 'ログアウト' },
      component: () => import('@/components/Pages/Logout.vue'),
    },
  ],
});

// titleタグの設定
const SERVICE_TITLE = 'Resee';
const DEFAULT_TITLE = `予約管理画面 | ${SERVICE_TITLE}`;
router.afterEach((to) => {
  const title = to.meta.title ? `${to.meta.title} | ${SERVICE_TITLE}` : DEFAULT_TITLE;
  document.title = title;
});

// ルート保護設定
router.beforeEach(async (to, from, next) => {
  // { meta: { restricted: true } } が付いている保護されているページにアクセス
  if (to.matched.some((record) => record.meta.restricted === true)) {
    // await axios
    //   .get(import.meta.env.VITE_APP_API_ENDPOINT + '/api/user')
    //   .then((res) => {
    //     auth.set(res.data);
    //   })
    //   .catch(() => {
    //     next({ path: '/login', query: { redirect: to.fullPath } });
    //     return;
    //   });
    try {
      await axios.get(import.meta.env.VITE_APP_API_ENDPOINT + '/api/user');
    } catch (error) {
      next({ path: '/login', query: { redirect: to.fullPath } });
      return;
    }
  } else if (to.matched.length === 0) {
    next({ path: '/login' });
    return;
  }
  next();
});
